import { render } from "./SquatLockerTerms.vue?vue&type=template&id=4a10a69c&scoped=true"
import script from "./SquatLockerTerms.vue?vue&type=script&lang=js"
export * from "./SquatLockerTerms.vue?vue&type=script&lang=js"

import "./SquatLockerTerms.vue?vue&type=style&index=0&id=4a10a69c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a10a69c"]])

export default __exports__